import { Dropdown, Flex, MenuProps } from "antd";
import UserIcon from "assets/users.svg";
import CommentIcon from "assets/comment.svg";
import ContactIcon from "assets/contact.svg";
import PostIcon from "assets/post.svg";
import Avatar from "assets/default-avatar.jpg";
import { Outlet, useNavigate } from "react-router-dom";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { removeToken } from "features/authUserSlice";
import styled from "styled-components";
import ImageLogo from "assets/logo.png";

const MENU = [
  {
    title: "Users Management",
    icon: UserIcon,
    path: "/user-management",
  },
  {
    title: "User Reports",
    icon: UserIcon,
    path: "/user-report",
  },
  {
    title: "Comment Reports",
    icon: CommentIcon,
    path: "/comment-report",
  },
  {
    title: "Contact Us",
    icon: ContactIcon,
    path: "/contact-us",
  },
  {
    title: "Post Report",
    icon: PostIcon,
    path: "/post-report",
  },
];

const Layout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState(window.location.pathname);

  const itemsAvt: MenuProps["items"] = [
    {
      key: "1",
      label: "Logout",
      onClick: () => dispatch(removeToken()),
    },
  ];
  const handleClick = useCallback(
    (path: string) => {
      navigate(path);
      setIsActive(path);
    },
    [navigate]
  );

  return (
    <LayoutWrapper>
      <LayoutLeft>
        <Flex
          className="logo"
          style={{ cursor: "pointer" }}
          onClick={() => handleClick("/")}
        >
          <img
            src={ImageLogo}
            width={"100%"}
            height={"80px"}
            alt="logo"
            style={{ objectFit: "contain" }}
          />
        </Flex>
        <Menu>
          {MENU.map((item, index) => {
            return (
              <MenuItem
                onClick={() => handleClick(item.path)}
                gap={"15px"}
                key={index}
              >
                <ImgItems src={item.icon} alt="" />
                <TextItem
                  style={{
                    fontWeight: isActive === item.path ? "700" : "normal",
                  }}
                >
                  {item.title}
                </TextItem>
              </MenuItem>
            );
          })}
        </Menu>
      </LayoutLeft>
      <Content>
        <Outlet />
      </Content>
      <LayoutTop>
        <Avt>
          <Dropdown menu={{ items: itemsAvt }}>
            <img src={Avatar} alt="" />
          </Dropdown>
        </Avt>
      </LayoutTop>
    </LayoutWrapper>
  );
};

export default Layout;

const LayoutWrapper = styled(Flex)``;

const LayoutLeft = styled(Flex)`
  width: 240px;
  min-width: 240px;
  background-color: #edf2f7;
  height: calc(100vh - 150px);
  margin-top: 80px;
  padding: 0 20px 70px 20px;
  position: fixed;
  left: 0px;
  display: flex;
  flex-direction: column;
`;

const Menu = styled("div")`
  width: 100%;
`;

const MenuItem = styled(Flex)`
  cursor: pointer;
  align-items: center;
  width: 100%;
  height: 30px;
  padding: 10px 15px;
`;

const ImgItems = styled("img")`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

const TextItem = styled("span")`
  font-size: 18px;
  font-weight: 400;
  &:hover {
    font-size: 18px;
    font-weight: 700 !important;
  }
`;

const Content = styled(Flex)`
  margin-top: 80px;
  padding: 30px;
  width: calc(100% - 340px);
  margin-left: 280px;
`;

const LayoutTop = styled(Flex)`
  background-color: #2d3748;
  height: 80px;
  width: calc(100vw - 80px);
  position: fixed;
  top: 0px;
  justify-content: end;
  padding: 0 40px;
  align-items: center;
`;

const Avt = styled(Flex)`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
